/* Tras enviar un formulario (newsletter, contacto) Shopify recarga la página: lleva el foco y la vista al mensaje [data-form-status]
   (los role=status/alert presentes al cargar no se anuncian solos). Va tras `load` porque el salto al ancla
   del navegador quita el foco si se pone antes. */
(() => {
  const msg = document.querySelector('[data-form-status]');
  if (!msg) return;
  const show = () => msg.scrollIntoView({ block: 'center', behavior: 'instant' });
  const go = () => setTimeout(() => {
    msg.focus({ preventScroll: true });
    show();
    // shortcut: en la home, ScrollTrigger y las imágenes tardías mueven el layout tras `load`; se reencuadra dos veces más.
    setTimeout(show, 400); setTimeout(show, 1200);
  }, 0);
  if (document.readyState === 'complete') go();
  else addEventListener('load', go, { once: true });
})();
